module.exports = __webpack_public_path__ + "static/media/nextroll.c0725151.png";